const initialState = () => ({
  wizardSnapshot: null,
});

const state = initialState();

// Getters
const getters = {
  getWizardSnapshot: (state) => state.wizardSnapshot,
};

// Ações
const actions = {
  clearState({ commit }) {
    commit('RESET');
  },

  salvarSnapshot({ commit }, snapshot) {
    commit('SET_WIZARD_SNAPSHOT', snapshot);
  },

  limparSnapshot({ commit }) {
    commit('SET_WIZARD_SNAPSHOT', null);
  },
};

// Mutações
const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },

  SET_WIZARD_SNAPSHOT(state, snapshot) {
    state.wizardSnapshot = snapshot;
  },
};

// Exportando módulo
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
